import React, { useEffect, useState } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Backdrop from "@mui/material/Backdrop";


const SpinnerWithTime = (props)=>{
    const [progress, setProgress] = useState(props.initialTime);
    const [open] = useState(true);
    useEffect(() => {
        const timer = setInterval(() => {
          setProgress((prevProgress) => (prevProgress <= 0 ? props.initialTime : prevProgress - 1));
        }, 800);
        return () => {
          clearInterval(timer);
        };
      }, []);
    return(
        <Backdrop sx={{  zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
  
        <Box sx={{color: '#fff', position: 'relative', display: 'inline-flex' }}>
         <CircularProgress  color="inherit" variant="determinate" value={progress} />
  
         <Box
           sx={{
             top: 0,
             left: 0,
             bottom: 0,
             right: 0,
             position: 'absolute',
             display: 'flex',
             alignItems: 'center',
             justifyContent: 'center',
           }}
         >
       <Typography variant="caption" component="div" color="text.secondary">
             {progress}s
           </Typography> 
         </Box>
       </Box> 
       </Backdrop>
    )
}


export default SpinnerWithTime